module.exports = __webpack_public_path__ + "img/IMG_1149_L_Foamcore.5f20ba7d.jpg";